import { ComponentView, ViewGenerator, ObservableArray, ViewModel } from "binder";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ITemplateSelector } from "../templateSelector";
import { getAsBoolean } from "../utilities";
import { ListViewModel } from "./list-viewModel"
import { FormExecutorViewModel } from "src/bpms/execution/formExecutor/formExecutor-viewModel";

export class ListView extends ComponentView<ListViewModel>{
    GetViewUniqueId(): string {
        return "V-0D15EB8B-E31C-4F69-B04C-39F3F00267FE"
    }
    loadHtml(): string {
        let element = require('./list.html').default;
        let style = require('./list.less');
        return element;
    }
    constructor() {
       super();
    }
    private itemTemplate : Node;
    private itemTemplateMapping:{[id:string]:Node}={};

    templateSelector(vm){
        let template : any;
        let newNode : Element;
        if(this.itemtemplateselector==null && stringIsNullOrEmpty(this.templateselectorfunction)==false){
            let templateSeletorProvider : ViewModel = this.dataContext;
            while(templateSeletorProvider!=null && (<ViewModel>templateSeletorProvider).getTypeId()!="VM-944D0986-9F07-4724-A37B-2DA704DD426D"){
                templateSeletorProvider = templateSeletorProvider.parentViewModel;
            }
            if(templateSeletorProvider!=null){
                this.itemtemplateselector = (<any>templateSeletorProvider).templateSelector
            }
        }
        if(this.itemtemplateselector && this.itemtemplateselector.getTemplate){
            template = this.itemtemplateselector.getTemplate(vm,this.templateselectorfunction);
            if(template){
                newNode = ViewGenerator.CreateFromPrototypeAndViewModel(template,vm);
            }
        }
        if(newNode==null){
            if(vm){
                let typeId = vm.getTypeId();
                let result = this.itemTemplateMapping[typeId];
                if(result)
                    newNode =  ViewGenerator.GetNodeByTemplate(vm,result);
            }
            if(newNode==null)
                newNode = ViewGenerator.GetNodeByTemplate(vm,this.itemTemplate);
        }
        return newNode;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLElement && node.classList.contains("template")){
                this.itemTemplate = super.removeAsTemplate(node);
            }else if(node instanceof HTMLElement){
                for (let index = 0; index < node.classList.length; index++) {
                    const element = node.classList[index];
                    if(element.startsWith('template-')){
                        let template = super.removeAsTemplate(node);
                        let type = element.substring(9);
                        this.itemTemplateMapping[type]=template;
                        break;
                    }
                }
            }else{
                this.firstlevelElement.append(node);
            }
        })
    }

    public set items(v: ObservableArray<ViewModel>) { 
        this._items = v; 
        this.updateInternalItems();
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set itemtemplateselector(v: ITemplateSelector) { 
        this._itemtemplateselector = v;
        this.updateInternalItems();
    } public get itemtemplateselector(): ITemplateSelector { return this._itemtemplateselector;} private _itemtemplateselector: ITemplateSelector;
    public set templateselectorfunction(v: string) { 
        this._templateselectorfunction = v; 
        this.updateInternalItems();
    } public get templateselectorfunction(): string { return this._templateselectorfunction;} private _templateselectorfunction: string;
    
    public set importanthasselectorfunction(v: boolean) { this._importanthasselectorfunction = getAsBoolean(v); } public get importanthasselectorfunction(): boolean { return this._importanthasselectorfunction;} private _importanthasselectorfunction: boolean;
    public set internalItems(v: ObservableArray<ViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<ViewModel> { return this._internalItems;} private _internalItems: ObservableArray<ViewModel>;
    updateInternalItems(){
        if((this.importanthasselectorfunction??false)==false){
            this.internalItems = this.items;
        }else{

            if(this.itemtemplateselector==null && stringIsNullOrEmpty(this.templateselectorfunction)==false){
                let templateSeletorProvider : ViewModel = this.dataContext;
                while(templateSeletorProvider!=null && (<ViewModel>templateSeletorProvider).getTypeId()!="VM-944D0986-9F07-4724-A37B-2DA704DD426D"){
                    templateSeletorProvider = templateSeletorProvider.parentViewModel;
                }
                if(templateSeletorProvider!=null){
                    this.itemtemplateselector = (<any>templateSeletorProvider).templateSelector
                }
            }

            if(this.itemtemplateselector!=null && stringIsNullOrEmpty(this.templateselectorfunction)==false){
                this.internalItems = this.items;
            }
        }
    }
}
